import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { useSetWindowTitle } from "@/wi-utilities.js";

interface BreadcrumbPathItem {
  title: string;
  path: string;
}

interface Breadcrumb {
  title: string;
  pageBreadcrumbPath: Array<string | BreadcrumbPathItem>;
  lastBreadcrumb?: string;
}

interface StoreInfo {
  breadcrumbs: Breadcrumb;
}

@Module
export default class BreadcrumbsModule extends VuexModule implements StoreInfo {
  breadcrumbs = {} as Breadcrumb;

  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getBreadcrumbs(): Breadcrumb {
    return this.breadcrumbs;
  }

  /**
   * Get breadcrumb array for current page
   * @returns object
   */
  get pageBreadcrumbPath(): Array<string | BreadcrumbPathItem> {
    return this.breadcrumbs.pageBreadcrumbPath;
  }

  /**
   * Get the last breadcrumb string for current page,
   * if it's specified, or the title by default
   * @returns object
   */
  get lastBreadcrumb(): string | undefined {
    return this.breadcrumbs.lastBreadcrumb || this.breadcrumbs.title;
  }

  /**
   * Get current page title
   * @returns string
   */
  get pageTitle(): string {
    return this.breadcrumbs.title;
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_MUTATION](payload) {
    this.breadcrumbs = payload;
    useSetWindowTitle(this.breadcrumbs.title);
  }

  @Action
  [Actions.SET_BREADCRUMB_ACTION](payload) {
    this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
  }
}
